import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Cargar script de Google Analytics
    const script = document.createElement("script");
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-XDVMVJM1T9";
    script.async = true;
    document.head.appendChild(script);

    // Inicializar Google Analytics
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", "G-XDVMVJM1T9");
  }, []);

  // Trackear cambios de página
  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-XDVMVJM1T9", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

export default GoogleAnalytics;
